export default "__VITE_ASSET__CueMK1jm__"